import type { TypePolicies } from "@apollo/client";

export const typePolicies: TypePolicies = {
  // Варианты прикреплённого опроса не нормализуются: их id это id варианта в
  // библиотеке, он общий у всех прикреплений одного опроса (один опрос можно
  // прикрепить к видео дважды). С ключом по id голоса одного прикрепления
  // перетирали бы голоса другого, поэтому варианты хранятся внутри своего
  // ContentPoll.
  ContentPollOption: { keyFields: false },
  // Блок и вариант письма рассылок (спека marketing-automations, фаза 1,
  // Task 9): `EmailBlock.id` уникален только внутри своего варианта (это
  // id редактора блоков, не Mongo _id), а `EmailTemplateVariant` id вообще
  // не имеет. Нормализация по id склеила бы одноимённые блоки/варианты
  // разных писем, как было с опросами (ContentPollOption выше).
  EmailBlock: { keyFields: false },
  EmailTemplateVariant: { keyFields: false },
  // Условия аудитории рассылки (спека marketing-automations, фаза 2, Task
  // 13): вложены в Automation.audience/AudienceEstimate-запрос, своего id
  // не имеют, а по умолчанию Apollo пишет предупреждение о слиянии полей
  // при нормализации таких объектов без ключа.
  AudienceFilter: { keyFields: false },
  AudienceCondition: { keyFields: false },
  // merge: список автоматизаций читает только часть счётчиков. Без слияния
  // его перечитывание после сохранения заменяло бы объект целиком, запрос
  // редактора терял бы свои поля и снова шёл бы в сеть (финальное ревью,
  // минор 1). Граф список читает тем же фрагментом AutomationGraphFields,
  // что и редактор, поэтому ему слияние не нужно.
  AutomationStats: { keyFields: false, merge: true },
  AutomationSkipCount: { keyFields: false },
  ContactImportResult: { keyFields: false },
  AudienceEstimate: { keyFields: false },
  // Узлы и связи графа автоматизации (спека marketing-automations, фаза 3,
  // Task 17): `id` узла и связи уникален только внутри своего графа, у
  // каждой автоматизации по событию есть узел с id "trigger". Нормализация
  // по id склеила бы одноимённые узлы разных автоматизаций, и редактор
  // показал бы чужой триггер или письмо. Вложенные объекты графа без id
  // (позиция, конфиги узлов, ошибки, счётчики) объявлены тут же, чтобы
  // Apollo не предупреждал о слиянии полей.
  AutomationNode: { keyFields: false },
  AutomationEdge: { keyFields: false },
  AutomationGraph: { keyFields: false },
  AutomationNodePosition: { keyFields: false },
  AutomationTriggerConfig: { keyFields: false },
  AutomationSendEmailConfig: { keyFields: false },
  AutomationGraphIssue: { keyFields: false },
  AutomationNodeStats: { keyFields: false },
  // Правила графа (Automation.graphRules и запрос automationGraphRules,
  // волна рефакторинга, пакет G): своего id нет, правила одного вида у
  // разных автоматизаций хранятся внутри каждой из них и заменяются целиком.
  AutomationGraphRules: { keyFields: false },
  AutomationNodeRule: { keyFields: false },
  AutomationTriggerRule: { keyFields: false },
  AutomationGraphLimits: { keyFields: false },
  AutomationTemplateOption: { keyFields: false },
  AutomationWaitUnitLimit: { keyFields: false },
  // Цепочки (фаза 4): конфиги шагов WAIT и CONDITION без своего id; id
  // правила выхода уникален только внутри своей цепочки (у многих цепочек
  // из шаблонов есть правило "goal"), нормализация склеила бы правила
  // разных цепочек, как узлы графа выше. Повторный вход, дневной лимит и
  // страница участников своего id не имеют.
  AutomationWaitConfig: { keyFields: false },
  AutomationConditionConfig: { keyFields: false },
  AutomationExitRule: { keyFields: false },
  AutomationReentry: { keyFields: false },
  AutomationEntryLimit: { keyFields: false },
  AutomationEnrollmentPage: { keyFields: false },
  // Пределы рассылок и аудитории (запрос marketingLimits): своего id нет,
  // объект один на платформу и при перечитывании заменяется целиком.
  MarketingLimits: { keyFields: false },
};
